import { Component, ElementRef, Inject, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { CropperComponent } from 'angular-cropperjs';
import { EventEmitter } from '@angular/core';
import { DialogService } from '../../../../shared/components/dialog/service/dialog.service';
import { ApiService, UtilService, VariablesService } from '../../../../shared/services';
import { DOCUMENT } from '@angular/common';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-upload-img',
  templateUrl: './upload-img.component.html',
  styleUrls: ['./upload-img.component.scss']
})
export class UploadImgComponent implements OnInit, OnChanges {

  @Input() isCropper;
  @Input() displayType;
  @Input() label;
  @Input() selectOptions;
  @Input() chooseOptions;
  @Input() medialURL;
  @Input() public info;
  @Output() uploadedMedia = new EventEmitter();
  draftId;

  imgForm: FormGroup;
  isLoading;
  previewImg;
  fileStatus;
  file;
  @ViewChild('fileInput') fileInput: ElementRef<HTMLInputElement>;
  @ViewChild('cropper') public cropper: CropperComponent;
  options = {
    aspectRatio: 750 / 430,
    movable: true,
    rotatable: false,
    zoomable: true,
    zoomOnWheel: true,
    dragMode: 'move',
    autoCropArea: true,
    cropBoxResizable: false,
    cropBoxMovable: false,
    guides: false
  };
  offsetX;
  offsetY;
  showPopover;

  constructor(
    private sanitizer: DomSanitizer,
    private dialogUtilService: DialogService,
    public util: UtilService,
    private vars: VariablesService,
    private api: ApiService,
    private fb: FormBuilder,
    @Inject(DOCUMENT) private document
  ) {

    this.imgForm = this.fb.group({
      imgControl: ['', Validators.required],
      costEst: ['', []]
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes && changes.selectOptions && changes.selectOptions.currentValue) {
      this.imgForm.addControl('imgType', this.fb.control('', Validators.required));
    }
  }

  ngOnInit(): void {
    this.setPopoverOffsetXAndY();
  }

  setPopoverOffsetXAndY() {
    if (this.util.isMobile()) {
      this.offsetX = -30;
      if (this.document.body.clientWidth < 375) {
        this.offsetY = -10;
      } else {
        this.offsetY = -40;
      }
    } else {
      this.offsetX = 40;
      this.offsetY = -200;
    }
  }

  openModal(template, text: string): void {
    this.imgForm.reset();

    this.dialogUtilService.closeDialog();
    this.dialogUtilService.openDialog({ title: text, content: template }, {
      height: 'auto',
      width: this.util.isMobile() ? '90vw' : '500px',
      panelClass: 'edit-update',
    });
    this.dialogUtilService.dialogRef.afterOpened().subscribe((res) => {
      if (text.match('Crop|Document')) {
        this.fileInput.nativeElement.click();
      }
    });
  }

  submitMedia(): void {
    this.imgForm.markAllAsTouched();
    if (this.imgForm.valid) {
      const payload: any = {
        image: this.file,
        display_type_1: this.displayType,
        treatment_cost: this.imgForm.get('costEst').value
      };
      if (this.isCropper) {
        const data = this.cropper.cropper.getData();
        for (const key of Object.keys(data)) {
          payload[key] = data[key];
        }
      }
      if (this.selectOptions) {
        payload.detail_1 = this.imgForm.get('imgType').value;
        payload.status = 3;
      }
      this.uploadMedia(payload);
    } else {
      this.util.checkValidForm(this.imgForm);
    }
  }

  uploadMedia(payload): void {
    this.isLoading = true;
    const docs = payload.display_type_1 === 'medicalbill' ? '/docs' : '';
    const url = environment.APP.API_URLS.UPLOAD_MEDIA(this.vars.campaignId) + docs;
    this.api.fileUpload(url, payload).subscribe((res) => {
      this.uploadedMedia.emit(res.data.media);
      this.isLoading = false;
      this.dialogUtilService.closeDialog();
      this.util.openSnackBar('Image added successfully!', 'success');
      this.previewImg = '';
    }, () => this.isLoading = false);
  }

  /** File upload validation */
  fileValidation(event): object {
    const regEx = /(\.jpg|\.jpeg|\.bmp|\.gif|\.png|\.pdf)$/i;
    if (event.target.files.length > 0) {
      const file: File = event.target.files[0];
      const fileSize = file.size / 1024 / 1024;
      if (regEx.exec(file.name)) {
        if (fileSize < 10) {
          return { message: 'Success', error: false };
        } else {
          return { message: 'File size exeeds 10MB', error: true };
        }
      } else {
        return { message: 'Unsupported file format', error: true };
      }
    }
  }

  /** Upload file listner */
  onFileChanged(event): void {
    this.fileStatus = this.fileValidation(event);
    if (!this.fileStatus?.error) {
      this.file = event.target.files[0];
      this.previewImg = this.sanitizer.bypassSecurityTrustResourceUrl(URL.createObjectURL(event.target.files[0]));
    }
  }

  closePreview(): void {
    this.previewImg = null;
    this.file = null;
    this.imgForm.get('imgControl').setValue('', { emitEvent: false });
  }

}
